export default "/images/518a2d080f29c9c195045fb8ef247795.avif";